import { useIntl } from '@leagueplatform/locales';
import { ErrorState } from '@leagueplatform/web-common-components';
import { Box, useMediaQuery, queryHelpers } from '@leagueplatform/genesis-core';
import type { MasonryRootErrorFallbackProps } from '@leagueplatform/masonry-engine';
import connectionErrorSvg from 'assets/connection-error.svg';

export const MasonryErrorFallback = ({
  retry,
}: MasonryRootErrorFallbackProps) => {
  const { formatMessage } = useIntl();
  const isMobile = useMediaQuery(queryHelpers.down('tablet'));

  return (
    <Box
      css={{
        display: 'flex',
        justifyContent: 'center',
        marginTop: '$three',
        padding: isMobile ? '$none' : '$three',
      }}
    >
      <ErrorState
        error={null}
        imageSrc={connectionErrorSvg}
        headingString={formatMessage({
          id: 'STR_ERROR_STATE_HEADING_GENERIC',
        })}
        bodyString={formatMessage({ id: 'STR_ERROR_STATE_BODY_API' })}
        buttonText={formatMessage({ id: 'STR_RELOAD' })}
        onButtonClick={retry}
      />
    </Box>
  );
};
